export const preBidsTableContainerSX = {
    display: "flex",
    flexDirection: "column",
    width: { md: "100%" },
    minWidth: { sm: "500px" },
};

export const preBidsTableSX = {
    width: "100%",
    mx: "auto",
};

export const preBackorderChipSX = {
    color: "white",
    backgroundColor: "#ffb700",
    border: "none",
    borderRadius: "5px",
    height: "16px",
    "& .MuiChip-label": {
        fontSize: "9px",
        lineHeight: "9px",
        marginTop: "1px",
    },
};

export const bidAmountEditButtonSX = {
    minWidth: "12px",
    padding: 0,
    marginBottom: "2px",
};

export const bidAmountEditIconSX = {
    color: "#21B2E7",
    fontSize: "13px",
    justifyContent: "flex-end",
};
